<div id="list-container">
  <div id="flex-container">
    <div id="card-list">
      <ng-container *ngFor="let card of routeData.gradeUnitList?.results">
        <app-grade-unit-card [gradeUnitListItem]="card"></app-grade-unit-card>
      </ng-container>
    </div>
  </div>
</div>
